import { useDeviceType } from '@packages/shared/src/hooks/useDeviceType/useDeviceType';
import type { ParagraphType } from '../../../interfaces/components';
import { ComponentRecognizer } from '../ComponentRecognizer/ComponentRecognizer';

export const CmsGroupItem = ({
  item,
  rowGap,
  index,
  colGap,
  cellsPerRowDesktop,
  cellsPerRowMobile,
}: {
  item: ParagraphType;
  rowGap: string;
  index: number;
  colGap: string;
  cellsPerRowDesktop: number;
  cellsPerRowMobile: number;
}) => {
  const { isMobile } = useDeviceType();
  const cellsPerRow = isMobile ? cellsPerRowMobile : cellsPerRowDesktop;
  return (
    <div
      key={item.id}
      className="grow-0 [&_.cms-group]:h-full [&_.cms-group]:max-w-full [&_.cms-group]:xl:container [&_.cms-group]:xl:mx-auto!"
      style={{
        flexBasis:
          colGap !== '0'
            ? `calc((100% - ${colGap} * ${cellsPerRow - 1}) / ${cellsPerRow})`
            : `calc(100% / ${cellsPerRow})`,
        marginBottom: rowGap,
        // only apply the margin if it is not the last item in the row
        marginRight: cellsPerRow > 1 && (index + 1) % cellsPerRow ? colGap : 0,
        maxWidth: `calc(100% / ${cellsPerRow})`,
      }}
    >
      <ComponentRecognizer item={item} />
    </div>
  );
};
